import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { OracleServiceCloudLinkedService } from 'app/model/linkedservice/oracle-service-cloud.linkedservice';
import { OracleServiceCloudCopySource } from 'app/model/pipeline/copysource/oracle-service-cloud.copysource';
import { useEncryptedEndpointsRadioSwitch } from 'app/registries/linked-service/linked-service-shared-fields';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';
import { format, stringIsNullOrEmpty } from 'app/shared/utils/string.util';

export const oracleServiceCloudMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(OracleServiceCloudLinkedService).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.OracleServiceCloud_DisplayText),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-Oracle'
    },
    isFirstClass: true,
    supportDatasetV2: true,
    category: ['ServicesApps'],
    copySinkTypes: [],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    warningTooltip: stringResources.Connector_Legacy_IsDeprecatedHint,
    notShowInTypeSelection: true,
    copySourceTypes: [Metamodel.modelFor(OracleServiceCloudCopySource).name],
    controls: [
        {
            type: 'textbox',
            bind: 'host',
            label: stringResources.ModelName_Host,
            required: true,
            placeholder: stringResources.OracleServiceCloud_Host_Placeholder,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            warningMessageCalculator: (value: string) =>
                stringIsNullOrEmpty(value) ? '' : stringResources.infoSentViaUrlWarning,
            isLabelVertical: true
        },
        {
            type: 'textbox',
            bind: 'username',
            label: stringResources.ModelName_UserName,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        },
        {
            type: 'dynamic-akv-switcher',
            bind: 'password',
            label: stringResources.ModelName_Password,
            child: {
                type: 'password',
                label: stringResources.ModelName_Password,
                required: true,
                isLabelVertical: true
            },
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            description: format(stringResources.AzureKeyVaultSecretName_Tooltip_Template,
                format(stringResources.ModelName_LinkedServiceTemplate, stringResources.OracleServiceCloud_DisplayText),
                stringResources.ModelName_Password)
        },
        useEncryptedEndpointsRadioSwitch
    ]
};
